// parseDayMonthYear reads a dd/mm/yyyy date, the format the document analysis
// reports its dates in.
export function parseDayMonthYear(value:string):Date | null{
	if (!value) return null;
	let parts = value.split("/");
	if (parts.length != 3) return null;
	let day = parseInt(parts[0], 10);
	let month = parseInt(parts[1], 10) - 1;
	let year = parseInt(parts[2], 10);
	if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
	return new Date(year, month, day);
}

// daysUntil counts whole days from today, so a date later today counts as 0.
// Null when there is no date to count to.
export function daysUntil(date:Date | null):number | null{
	if (!date) return null;
	let today = new Date();
	today.setHours(0, 0, 0, 0);
	let target = new Date(date.getTime());
	target.setHours(0, 0, 0, 0);
	return Math.round((target.getTime() - today.getTime()) / 86400000);
}

// dayKey identifies the day of a date, to group documents by the day they came
// in.
export function dayKey(date:Date):string{
	return `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
}
